import React from 'react';
/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */

export var TabContext = /*#__PURE__*/React.createContext({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/es/TabContext.js
// module id = 102
// module chunks = 28